export const overrideGrid = (theme) => {
  theme.overrides.MuiGrid = {
    item: {
      padding: '4px 8px 4px 0'
    }
  };
};
